module.exports = __webpack_public_path__ + "static/media/fill_grey_24.291ea341.svg";